import React from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import axios from 'axios';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import api from "../../api/Api";
import AxiosMaster from '../../AxiosFactory';
import {isClinicMasterOrClinic, clinicmaster_id, getClinicUserId} from '../../util/globalHelper'

// @material-ui/icons
import Face from "@material-ui/icons/PersonOutline";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardFooter from "../../components/Card/CardFooter.jsx";
import localStorageHelper from "./../../localStorageHelper"
import logo from "assets/img/logo-01.png";
import {NavLink} from "react-router-dom";

import loginPageStyle from "../../assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import Auth from '../../Auth'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {
    reload
} from '../../redux/global'

class Login extends React.Component {
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            username: "",
            password: "",
            redirect: false
        };
        this.onChange = this.onChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.onError = this.onError.bind(this)
        this.onSuccess = this.onSuccess.bind(this)
        this.login = this.login.bind(this)
        this.callLoginApi = this.callLoginApi.bind(this)
    }

    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        setTimeout(
            function () {
                this.setState({cardAnimaton: ""});
            }.bind(this),
            700
        );
    }

    onChange(name, e) {
        const state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    onSubmit(event) {
        event.preventDefault();
        (this.state.username !== "" || this.state.password !== "") ? this.login() : this.onError("Please fill the deatils")

    }

    onError(message) {
        var msgcolor = {message: message, color: "danger"};
        this.props.generateNotification(msgcolor);
    }

    onSuccess(message) {
        var msgcolor = {message: message, color: "success"};
        this.props.generateNotification(msgcolor);
    }

    login() {
        const postBody = {
            "username": this.state.username,
            "password": this.state.password
        }
        this.callLoginApi(postBody)
    }


    render() {
        // if (this.state.redirect || localStorageHelper.getItem("user_detail"))
        //     return <Redirect to={{pathname: "/dashboard"}}/>;
        const {classes} = this.props;
        return (
            <div className={classes.content}>
                <div className={classes.container}>
                    <GridContainer justify="center">
                        <GridItem xs={8} sm={6} md={4}>
                            <img src={logo} className={classes.avatarImg} style={{maxWidth: "100%", marginTop: -100}}
                                 alt="..."/>
                            <br/> <br/>
                        </GridItem>
                    </GridContainer>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={6} md={4}>
                            <br/> <br/>
                        </GridItem>
                    </GridContainer>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={6} md={4}>
                            <form>
                                <Card login className={classes[this.state.cardAnimaton]}>
                                    <CardHeader
                                        className={`${classes.cardHeader} ${classes.textCenter}`}
                                        color="info">
                                        <h4 className={classes.cardTitle}>Login to Healthspace</h4>
                                    </CardHeader>
                                    <CardBody>
                                        <CustomInput
                                            labelText="Username"
                                            id="username"
                                            name="username"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.onChange("username", event),
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <Face className={classes.inputAdornmentIcon}/>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                        <CustomInput
                                            labelText="Password"
                                            id="password"
                                            name="password"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.onChange("password", event),
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {/*<LockOutline*/}
                                                        {/*    className={classes.inputAdornmentIcon}*/}
                                                        {/*/>*/}
                                                    </InputAdornment>
                                                ),
                                                type: "password"
                                            }}
                                        />
                                    </CardBody>
                                    <CardFooter className={classes.justifyContentCenter}>
                                        <Button color="info" simple size="lg" block onClick={this.onSubmit}>
                                            Login
                                        </Button>
                                    </CardFooter>

                                </Card>
                            </form>
                        </GridItem>
                    </GridContainer>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={6} md={4}>
                            <br/> <br/>
                        </GridItem>
                    </GridContainer>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={6} md={4}>
                            <p className="text-center">If you don't have an account yet &nbsp;


                                <strong> <a color="info" target="_blank"
                                            href="https://www.myhealthspace.in/for-doctors">Register Here</a>
                                </strong>
                            </p>
                            <br/> <br/>
                        </GridItem>
                    </GridContainer>

                </div>
            </div>
        );
    }

    callLoginApi(data) {
        api.loginApi(data).then(json => {
            if (json.isError === true) {
                this.onError(json.error.message)
            } else {
                Auth.authenticate();
                localStorageHelper.setItem("user_detail", json.data.data);
                localStorageHelper.setItem("user_name", json.data.data.name);
                localStorageHelper.setItem("login", true);
                localStorageHelper.setItem("auth_token", json.data.data.auth_token);
                localStorageHelper.setItem("superAdmin", json.data.data.roles[0].is_super_admin);
                localStorageHelper.setItem("roles", json.data.data.roles);
                localStorageHelper.setItem("selected_role", json.data.data.roles[0]);
                if (json.data.data.roles[0].is_super_admin === false) {
                    localStorageHelper.setItem("role", json.data.data.roles[0].clinic_permission_id.role_name);
                    localStorageHelper.setItem("permission", json.data.data.roles[0].clinic_permission_id.role_access)
                }

                // json.data.data.roles[0].is_super_admin ? null : localStorageHelper.setItem("permission", json.data.data.roles[0].clinic_permission_id.role_access);
                this.onSuccess(json.data.data.name + " Successfully Logged In!");
                delete axios.defaults.headers.common;
                axios.defaults.headers.common = {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("auth") ? `Bearer ${JSON.parse(localStorage.getItem("auth_token"))}` : ``,
                    'clinic': localStorage.getItem("auth") ? `${getClinicUserId()}` : ``,
                    'clinic-master': localStorage.getItem("auth") ? `${clinicmaster_id()}` : ``
                };
                json.data.data.roles[0].is_super_admin ?
                    this.props.history.push(localStorage.getItem("last_url") ? localStorage.getItem("last_url") : "/dashboard") :
                    this.props.history.push(localStorage.getItem("last_url") ? "/newdash" + localStorage.getItem("last_url") : "/newdash/dashboard");
                this.props.reload();


            }

        }).catch(error => {
            this.onError("Incorrect Username/Password")
        })
    }
}

Login.propTypes = {
    classes: PropTypes.object.isRequired
};


const mapStateToProps = ({global}) => ({
    reloadState: global.reloadState,
})

const mapDispatchToProps = dispatch => bindActionCreators({
    reload
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(loginPageStyle)(Login));



// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx